<template>
  <component :is="temp" />
</template>
<script>
export default {
  components: {
    default1: () => import('~/template/header/default1'),
    dfcp: () => import('~/template/header/dfcp'),
  },
  computed: {
    appConfig(){
      console.log('#### header appconfig', this.$store.state.service.appConfig)
      return this.$store.state.service.appConfig;
    },
    temp(){
      if(Object.keys(this.appConfig).length){
        return this.appConfig.pc_head_template
      }else{
        return 'dfcp'
      }
    }
  },
  methods: {}
}
</script>

<style lang="less">
</style>
